import { useTranslation } from "react-i18next"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { SubscriptionsCreateRecurrenceTabs } from "@/components/subscriptions/create-recurrence/tabs"
import { FRONTEND_ROUTES } from "@/constants"

export function CreateRecurrencePage() {
  const { t } = useTranslation()

  return (
    <DashboardContainer>
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              href: FRONTEND_ROUTES.SUBSCRIPTIONS.href,
              label: t("sidebar.subscriptions"),
            },
            {
              label: t(
                "pages.subscriptions.createRecurrence"
              ),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <h1 className="page-title">
          {t("pages.subscriptions.createRecurrence")}
        </h1>
        <SubscriptionsCreateRecurrenceTabs />
      </section>
    </DashboardContainer>
  )
}
